export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-semibold bg-primary-100 text-primary-700 rounded-full mb-5">
              每日赛事 · 精彩不断
            </span>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              51每日大赛
              <span className="block text-primary-600 mt-1">
                每日大赛入口网站与最新网址大全
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              作为每日大赛资深用户的首选导航平台，51每日大赛为您整合每日大赛官方网站入口、最新可用网址与APP下载方式，一站式解决访问难题。
              无论您是老用户还是初次接触，我们持续追踪每日大赛官方动态，确保每一个入口都经过验证、每一个网址都保持最新。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">实时更新</div>
                <div className="text-xs text-foreground-500 mt-1">入口状态监控</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600">多端覆盖</div>
                <div className="text-xs text-foreground-500 mt-1">Web / iOS / Android</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">安全可靠</div>
                <div className="text-xs text-foreground-500 mt-1">官方渠道验证</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-sm"
              >
                <i className="ri-download-2-line"></i>
                下载每日大赛APP
              </a>
              <a
                href="#cards"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-background-200 text-foreground-800 font-semibold rounded-lg hover:bg-background-300 transition-colors text-sm"
              >
                <i className="ri-arrow-right-line"></i>
                查看最新入口
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20abstract%20digital%20composition%20with%20warm%20orange%20and%20golden%20gradients%2C%20dynamic%20flowing%20geometric%20shapes%20suggesting%20energy%20and%20competition%2C%20soft%20glowing%20accents%20on%20a%20clean%20light%20background%2C%20modern%20aesthetic%20with%20depth%20and%20movement%2C%20editorial%20quality%2C%20inspiring%20and%20uplifting%20atmosphere%20with%20warm%20light%20diffusion&width=960&height=720&seq=hero-main-2026&orientation=landscape"
                alt="51每日大赛 — 每日大赛入口网站与最新网址大全"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-900/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}